module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAuMzg0IiBoZWlnaHQ9IjQyLjU0MSIgdmlld0JveD0iMCAwIDMwLjM4NCA0Mi41NDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTUuMTkyIDRWMzguNTQxTTMuNSAyNi44NDlMMTUuMTkyIDM4LjU0MUwyNi44ODQgMjYuODQ5IiBzdHJva2U9IiNEOTUzNEYiIHN0cm9rZS13aWR0aD0iNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/v2/arrow-change-down-no-padding.svg
// module id = HqNE
// module chunks = 65